import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import { useNavigate } from "react-router";
import { RoutesList } from "@/router/routesList";
import { useCreateSportMutation } from "@/store/api";
import { useSetPageData } from "@/tools/hooks";
import { SportEditForm } from "./components/SportEditForm";
import { convertToCreateDto } from "./mappers/convertToCreateDto";
import { getEmptySport } from "./mappers/getEmptySport";
export var SportCreatePage = function () {
    var _a = useCreateSportMutation(), sportCreateAction = _a[0], sportCreateState = _a[1];
    var saveFormHandler = function (data) {
        try {
            sportCreateAction({
                createSportDto: convertToCreateDto(data),
            });
        }
        catch (err) {
            console.error(err);
        }
    };
    var cancelFormHandler = function () {
        navigate(RoutesList.Manage.getSportsList());
    };
    var navigate = useNavigate();
    useEffect(function () {
        if (sportCreateState.isSuccess) {
            navigate(RoutesList.Manage.getSportsList());
        }
    }, [sportCreateState.isSuccess]);
    useSetPageData({ title: "Вид спорта" });
    return (_jsx(SportEditForm, { isCreate: true, data: getEmptySport(), onSave: saveFormHandler, onCancel: cancelFormHandler }));
};
